import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource = '/operations/job_group_log/'
const detailResource = '/operations/job_group_log_detail/'
const tableResource = '/operations/job_group_log_table/'
const setReportIdResource='/operations/job_group_log/set_report_id/'

export default {
    get(){
        return Client.get(resource);
    },
    getWithId(id){
        return Client.get(`${detailResource}?id=${id}`)
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    setReportId(id,reportId){
        return Client.put(`${setReportIdResource}${id}/${reportId}/`);
    }
}